import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../../../../context/LoadingContext";
import AllProcurementDocuments from "./AllProcurementDocuments";
import { Auth } from "aws-amplify";
import { jwtDecode } from "jwt-decode";
import { getParameterFromManager } from "../../../../services/Utils";
import {
  fetchData,
  searchfetchQueries,
  postQuery,
  uploadVideoToS3,
} from "../../../Requirement/services/RequirementServices";

const ProcurementDocumentVault = () => {
  const [activeTab, setActiveTab] = useState("All Documents");
  const [documentTypes, setDocumentTypes] = useState([]);
  const [allProjectList, setAllProjectList] = useState([]);
  const [activeUser, setActiveUser] = useState("");
  const { setLoading } = useLoading();
  const navigate = useNavigate();

  const loadProjectList = useCallback(async () => {
    setLoading(true);
    try {
      const [initialResponse] = await Promise.all([
        fetchData({
          target: "listProjects",
          userOrder: "ProjectID",
          rowStart: 0,
          pageSize: 1,
        }),
      ]);

      const totalCount = initialResponse?.total || initialResponse?.length || 0;

      if (totalCount > 0) {
        const [allProducts] = await Promise.all([
          searchfetchQueries({
            target: "listProjects",
            userOrder: "ProjectID",
            rowStart: 0,
            pageSize: totalCount,
          }),
        ]);
        setAllProjectList(allProducts);
      } else {
        setAllProjectList([]);
      }
    } catch (error) {
      console.error("Error loading projects: ", error);
      setAllProjectList([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  // Load DocumentTypes
  const loadDocumentTypes = useCallback(async () => {
    setLoading(true);
    try {
      const [allDocumentTypes] = await Promise.all([
        fetchData({
          target: "listDropDownOptions",
          userOrder: "Value",
          rowStart: 0,
          pageSize: 1000,
          filterTerms: { Type: "ProcureDocType" },
        }),
      ]);
      if (allDocumentTypes.items.length > 0) {
        setDocumentTypes(allDocumentTypes.items);
      } else {
        setDocumentTypes([]);
      }
    } catch (error) {
      console.error("Error loading ProcureDocType: ", error);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  console.log("activeTab::", activeTab);
  const tabs = ["All Documents", ...documentTypes.map((doc) => doc.Value)];
  const renderTabContent = () => {
    return (
      <AllProcurementDocuments
        tabFilter={activeTab}
        categories={documentTypes}
        allProjectList={allProjectList}
        activeUser={activeUser}
      />
    );
  };

  useEffect(() => {
    console.log("Procurement Vault");
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);

        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_ADMINS")) {
          await Auth.signOut();
          navigate("/");
        }else {
          setActiveUser(user.attributes.email);
        }
        await getParameterFromManager("INR_TO_USD");
      } catch (error) {
        await Auth.signOut();
        navigate("/");
      }
    };

    checkUser();
    loadDocumentTypes();
    loadProjectList();
  }, [navigate, loadDocumentTypes, loadProjectList]);

  return (
    <div className="buyer-layout">
      <div className="amtpl-tabs">
        <div className="content3">
          <main className="main-content">
            <div className="main-tab">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`buttonclass ${
                    activeTab === tab ? "active" : "notactive"
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="row">{renderTabContent()}</div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default ProcurementDocumentVault;
